export const FERTIGATION_LINE_TYPE: FertigationLineType[] = [
  { id: '0', name: 'Serial' },
  { id: '1', name: 'Parallel' },
]

export interface FertigationLineType {
  id: string
  name: string
}
